import { cn } from '../../lib/utils';
import { transCls } from '../../const/ui';
import { SearchInput } from '../agent-helper/search-input';
import { TreeItemNode } from './tree-item-node';
import { AppGroupFolder } from './app-group-folder';
import { OtherAppSection } from './other-app-section';
import type { IAppDetail } from '@baishuyun/types';
import type { EntryTreeItem, BsEntrySelectChangeResult } from './types';

export function EntryPopover({
  searchQuery,
  onSearchChange,
  currentAppTree,
  currentAppId,
  otherAppIds,
  appDetails,
  selectedEntryId,
  hasCurrentApp,
  hasOtherApps,
  hasAnyContent,
  hasSearch,
  showCurrentAppEntriesOnly = false,
  onSelect,
}: {
  searchQuery: string;
  onSearchChange: (v: string) => void;
  currentAppTree: EntryTreeItem[];
  currentAppId: string | undefined;
  otherAppIds: string[];
  appDetails: Record<string, IAppDetail>;
  selectedEntryId: string | undefined;
  hasCurrentApp: boolean;
  hasOtherApps: boolean;
  hasAnyContent: boolean;
  hasSearch: boolean;
  showCurrentAppEntriesOnly?: boolean;
  onSelect: (result: BsEntrySelectChangeResult) => void;
}) {
  return (
    <div
      className={cn(
        'bg-white rounded-[10px] shadow-[0px_0px_10px_0px_rgba(0,0,0,0.04)] p-[4px]',
        'flex flex-col gap-[4px]',
        transCls,
      )}
    >
      <SearchInput value={searchQuery} onChange={onSearchChange} />

      <div className="flex flex-col gap-0 max-h-[400px] overflow-y-auto">
        {hasCurrentApp && (
          <AppGroupFolder label="当前应用表单" searchQuery={searchQuery}>
            {currentAppTree.length > 0 ? (
              currentAppTree.map((node) => (
                <TreeItemNode
                  key={node.id}
                  item={node}
                  selectedEntryId={selectedEntryId}
                  appId={currentAppId!}
                  section="current"
                  onSelect={onSelect}
                />
              ))
            ) : hasSearch ? (
              <div className="text-[12px] text-[#999999] py-[8px] pl-[22px]">
                无匹配结果
              </div>
            ) : (
              <div className="text-[12px] text-[#999999] py-[8px] pl-[22px]">
                暂无表单
              </div>
            )}
          </AppGroupFolder>
        )}

        {hasOtherApps && !showCurrentAppEntriesOnly && (
          <AppGroupFolder label="其他应用表单" searchQuery={searchQuery}>
            {otherAppIds.map((appId) => (
              <OtherAppSection
                key={appId}
                appId={appId}
                appDetail={appDetails[appId]}
                searchQuery={searchQuery}
                selectedEntryId={selectedEntryId}
                section="other"
                onSelect={onSelect}
              />
            ))}
          </AppGroupFolder>
        )}

        {!hasAnyContent && (
          <div className="text-[14px] text-[#999999] py-[12px] text-center">
            暂无应用
          </div>
        )}
      </div>
    </div>
  );
}
